import React from "react";
import { Image, Link, Text } from "@sitecore-jss/sitecore-jss-react";
import Chevron from "@clarion/foundation/dist/Theming/icons/Chevron";
import "./index.css";
const FooterPrimary = ({
  fields,
  imageParams,
  templateIds,
  socialLinks = [],
  footerLinks = []
}) => {
  const logoPath = fields.Logo?.value;
  const imageParameters = imageParams ? imageParams : {
    w: 200,
    h: "auto",
    mw: 200
  };
  const logoWidth = logoPath.width ? logoPath.width : 130;
  const logoHeight = logoPath.height ? logoPath.height : 56;
  for (let i = 0; i < fields.items.length; i += 1) {
    let item = fields.items[i];
    switch (item.templateId) {
      case templateIds.FooterLink:
        {
          footerLinks.push(item);
          break;
        }
      case templateIds.SocialMediaFooter:
        {
          socialLinks.push(item);
          break;
        }
      default:
        {
          break;
        }
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "footer__primary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "qa-footer__primary-wrapper footer__primary-wrapper wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer__logo"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "qa-footer-img",
    width: logoWidth,
    height: logoHeight,
    media: fields.Logo,
    imageParams: imageParameters
  })), /*#__PURE__*/React.createElement("div", {
    className: "footer__primary-container"
  }, footerLinks.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "qa-footer__links-container footer__links-container"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "footer__links"
  }, footerLinks.map(item => {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id,
      className: "qa-footer__item footer__item"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "footer__link",
      field: item.fields.Link
    }, item.fields.Link.value.text, /*#__PURE__*/React.createElement(Chevron, {
      className: "footer__chevron"
    })));
  }))), socialLinks.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "qa-footer__social footer__social"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: fields.SocialMediaTitle,
    className: "qa-footer__social-header footer__social-header"
  }), /*#__PURE__*/React.createElement("ul", {
    className: "footer__social-list"
  }, socialLinks.map(item => {
    return /*#__PURE__*/React.createElement("li", {
      className: "footer__social-item",
      key: item.id
    }, /*#__PURE__*/React.createElement(Link, {
      className: "footer__social-link",
      field: item.fields.Link
    }, /*#__PURE__*/React.createElement(Image, {
      className: "footer__icon",
      width: "24",
      height: "24",
      media: item.fields.Logo,
      imageParams: {
        w: 40,
        h: "auto",
        mw: 40
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "visually-hidden"
    }, item.fields.Link.value.text)));
  }))))));
};
export default FooterPrimary;